import React from "react"
import { Box, TextField, MenuItem, TextFieldProps } from "@mui/material"
import { ToggleButton } from "@mui/material"

import { StyledToggleButtonGroup } from "components/Configurations/SystemAndLengthCombinationConfigurationInput"
import SystemConfigurationDialog from "components/Dialogs/SystemConfigurationDialog"

import useSystemsConfiguration from "@secureo/common/hooks/cylinderConfigurations/useSystemsConfiguration"

import { SystemCylinderConfiguration } from "@secureo/common/typings/Product"

const SystemConfigurationInput = ({
	systems,
	selectedSystem,
	onSystemChange,
	disabled = false,
	systemConfigurationToolTip,
	margin = "normal",
	showLabel = true,
	isLockingSystem = false,
}: Props) => {
	const { systemInputProps, availableSystem } = useSystemsConfiguration(
		systems,
		selectedSystem,
		onSystemChange,
	)

	const numberOfSystems = systems.length

	if (numberOfSystems > 10 || isLockingSystem)
		return (
			<div>
				{showLabel && (
					<Box mt={1} style={{ display: "flex", alignItems: "center" }}>
						<SystemConfigurationDialog
							systemConfigurationToolTip={systemConfigurationToolTip}
						/>
					</Box>
				)}
				<TextField
					id="variant"
					label="Ausführung"
					value={systemInputProps.value}
					onChange={(event) => systemInputProps.onChange(event.target.value)}
					margin={margin}
					variant="filled"
					select
					fullWidth
					disabled={disabled}
				>
					{availableSystem.map(({ system }) => {
						return (
							<MenuItem key={system} value={system}>
								{system}
							</MenuItem>
						)
					})}
				</TextField>
			</div>
		)

	return (
		<div>
			<Box style={{ display: "flex", alignItems: "center" }}>
				<SystemConfigurationDialog
					systemConfigurationToolTip={systemConfigurationToolTip}
				/>
			</Box>
			<StyledToggleButtonGroup
				value={systemInputProps.value}
				onChange={(_, selectedSystem) => systemInputProps.onChange(selectedSystem)}
				exclusive
				aria-label="text alignment"
				style={{ display: "flex", flexWrap: "wrap" }}
			>
				{availableSystem.map(({ system }) => {
					return (
						<ToggleButton
							key={system}
							value={system}
							disabled={disabled}
							style={{ marginBottom: 8 }}
						>
							<strong>{system}</strong>
						</ToggleButton>
					)
				})}
			</StyledToggleButtonGroup>
		</div>
	)
}

interface Props {
	systems: SystemCylinderConfiguration[]
	selectedSystem: string
	onSystemChange: (selectedSystem: string) => void
	disabled?: boolean
	systemConfigurationToolTip?: string
	showLabel?: boolean
	margin?: TextFieldProps["margin"]
	isLockingSystem?: boolean
}

export default SystemConfigurationInput
